/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SalesCallLiveStatus
 */
export interface SalesCallLiveStatus {
  /**
   *
   * @type {boolean}
   * @memberof SalesCallLiveStatus
   */
  hasDialpadCall: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SalesCallLiveStatus
   */
  callEnded: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SalesCallLiveStatus
   */
  recapReady: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SalesCallLiveStatus
   */
  actionItemsReceived: boolean;
  /**
   *
   * @type {string}
   * @memberof SalesCallLiveStatus
   */
  recapSummary?: string | null;
}

/**
 * Check if a given object implements the SalesCallLiveStatus interface.
 */
export function instanceOfSalesCallLiveStatus(
  value: object,
): value is SalesCallLiveStatus {
  if (!("hasDialpadCall" in value) || value["hasDialpadCall"] === undefined)
    return false;
  if (!("callEnded" in value) || value["callEnded"] === undefined) return false;
  if (!("recapReady" in value) || value["recapReady"] === undefined)
    return false;
  if (
    !("actionItemsReceived" in value) ||
    value["actionItemsReceived"] === undefined
  )
    return false;
  return true;
}

export function SalesCallLiveStatusFromJSON(json: any): SalesCallLiveStatus {
  return SalesCallLiveStatusFromJSONTyped(json, false);
}

export function SalesCallLiveStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SalesCallLiveStatus {
  if (json == null) {
    return json;
  }
  return {
    hasDialpadCall: json["hasDialpadCall"],
    callEnded: json["callEnded"],
    recapReady: json["recapReady"],
    actionItemsReceived: json["actionItemsReceived"],
    recapSummary:
      json["recapSummary"] == null ? undefined : json["recapSummary"],
  };
}

export function SalesCallLiveStatusToJSON(json: any): SalesCallLiveStatus {
  return SalesCallLiveStatusToJSONTyped(json, false);
}

export function SalesCallLiveStatusToJSONTyped(
  value?: SalesCallLiveStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    hasDialpadCall: value["hasDialpadCall"],
    callEnded: value["callEnded"],
    recapReady: value["recapReady"],
    actionItemsReceived: value["actionItemsReceived"],
    recapSummary: value["recapSummary"],
  };
}
